export const storeProducts = [
  {
    id: 1,
    title: "Google Pixel - Black",
    img: "img/product-1.png",
    price: 56999,
    company: "GOOGLE",
    info:
      "8 GB RAM | 128 GB ROM | 12.7 cm (5 inch) Full HD Display | 12.3MP Rear Camera | 8MP Front Camera | 2770 mAh Battery | Qualcomm Snapdragon 821 64-bit Quad Core 2.15GHz Processor | Single Sim | Bottom Firing Speaker, 3 Microphones (2 Front, 1 Rear), Adaptive Audio Amplifier | 1920 x 1080 Full HD | 16:9 Aspect Ratio, Material: Anodised Aluminium (Corning Gorilla Glass 4), Oleophobic Coating, RGB LED Notification Light ",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Samsung S7",
    img: "img/product-2.png",
    price: 30499,
    company: "SAMSUNG",
    info:
      "6 GB RAM | 64 GB ROM | Expandable Upto 200 GB | 13.97 cm (5.5 inch) Quad HD Display | 12MP Rear Camera | 5MP Front Camera | 3600 mAh Li-Ion Battery | Exynos 8890 Processor | Dual Sim | 2560 X 1440 Pixels Quad HD Display | Super AMOLED Screen | Android Marshmallow 6 | Octa Core | clock speed 2.3 GHz | Dual Pixel, Auto Focus, Motion Mode, Panorama Mode, f/1.7, Hyperlapse, Slow Motion, Pro-mode, Live Broadcast, Video Collage, Virtual Shot, Food Mode",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "HTC 10 - Black",
    img: "img/product-3.png",
    price: 48999,
    company: "htc",
    info:
      "6 GB RAM | 64 GB ROM | The mobile measures 145.9 mm x 71.9 mm x 9.0 mm; and weighs around 161 grams. The mobile from HTC features 5.2 inches (13.21 cm) display that has a resolution of 1440 x 2560 pixels | It is equipped with Octa core (2.2 GHz, Quad core, Kryo + 1.5 GHz, Quad core, Kryo) Qualcomm Snapdragon 820 MSM8996 | HTC 10 runs Android v6.0 (Marshmallow) operating system and is packed with 3000 mAh battery | 12 MP camera | 5 MP front camera | Light sensor, Proximity sensor, Accelerometer, Compass, Gyroscope",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "HTC 10 - White",
    img: "img/product-4.png",
    price: 50425,
    company: "htc",
    info:
      "6 GB RAM | 64 GB ROM | Color: favorite white | The mobile measures 145.9 mm x 71.9 mm x 9.0 mm; and weighs around 161 grams. The mobile from HTC features 5.2 inches (13.21 cm) display that has a resolution of 1440 x 2560 pixels | It is equipped with Octa core (2.2 GHz, Quad core, Kryo + 1.5 GHz, Quad core, Kryo) Qualcomm Snapdragon 820 MSM8996 | HTC 10 runs Android v6.0 (Marshmallow) operating system | 3000 mAh battery | 12 MP camera | 5 MP front camera | Light sensor, Proximity sensor, Accelerometer, Compass, Gyroscope",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "HTC Desire 626s",
    img: "img/product-5.png",
    price: 14625,
    company: "htc",
    info:
      "HTC Desire 626s smartphone was launched in July 2015. The phone comes with a 5.00-inch touchscreen display with a resolution of 720x1280 pixels. HTC Desire 626s is powered by a 1.1GHz quad-core Qualcomm Snapdragon 210 processor. It comes with 1GB of RAM. The HTC Desire 626s runs Android 5.1 and is powered by a 2000mAh removable battery.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "Vintage Iphone",
    img: "img/product-6.png",
    price: 45000,
    company: "apple",
    info:
      "Antique peace | Apple iphone first (1st) model 2g original vintage antique collection Antique vintage Apple iPhone 2g first (1st) generation (original) sale or exchange its apple's first iphone model very rare and limited available in India very hard to find this mobile in this condition.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Iphone 7",
    img: "img/product-7.png",
    price: 20499,
    company: "apple",
    info:
      "4 GB Ram | 32 GB ROM | 11.94 cm (4.7 inch) Retina HD Display | 12MP Rear Camera | 7MP Front Camera | Apple A10 Fusion 64-bit processor and Embedded M10 Motion Co-processor | iOS 13 Compatible | Single Sim | 1.6 W/kg (over 1 g) SAR Limit, Head: 1.19, Body: 1.20 | Multi-touch Display, 1400:1 Contrast Ratio, Wide Color Display (P3), 625 cd/m2 Maximum Brightness, Dual Domain Pixels for Wide Viewing Angles, Fingerprint Resistant Oleophobic Coating, Display of Multiple Languages and Characters Simultaneously, Display Zoom, Reachability",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Smashed Iphone",
    img: "img/product-8.png",
    price: 6459,
    company: "apple",
    info:
      "iPhone 7 | Second Hand damaged screen | 4 GB Ram | 32 GB ROM | 11.94 cm (4.7 inch) Retina HD Display | 12MP Rear Camera | 7MP Front Camera | Apple A10 Fusion 64-bit processor and Embedded M10 Motion Co-processor | iOS 13 Compatible | Single Sim | 1.6 W/kg (over 1 g) SAR Limit, Head: 1.19, Body: 1.20 | Multi-touch Display, 1400:1 Contrast Ratio, Wide Color Display (P3), 625 cd/m2 Maximum Brightness, Dual Domain Pixels for Wide Viewing Angles, Fingerprint Resistant Oleophobic Coating",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Google Pixel - Black",
  img: "img/product-1.png",
  price: 56999,
  company: "GOOGLE",
  info:
    "4 GB RAM | 32 GB ROM | 12.7 cm (5 inch) Full HD Display | 12.3MP Rear Camera | 8MP Front Camera | 2770 mAh Battery | Qualcomm Snapdragon 821 64-bit Quad Core 2.15GHz Processor | Single Sim | Bottom Firing Speaker, 3 Microphones (2 Front, 1 Rear), Adaptive Audio Amplifier | 1920 x 1080 Full HD | 16:9 Aspect Ratio, Material: Anodised Aluminium (Corning Gorilla Glass 4), Oleophobic Coating, RGB LED Notification Light ",
  inCart: false,
  count: 0,
  total: 0
};
